export enum DisplayType{
  Badge = 'badge',
  Icon = 'icon'
}
